const host = process.env.VUE_APP_API_URL;

const apiBaseUrl = '/api/';

export { host, apiBaseUrl };
